<section class="table__pagination">
  <button
    class="table__pagination__button"
    type="button"
    [disabled]="disablePrevious"
    (click)="goToFirstPage()"
    [attr.aria-label]="'Go to first page'"
    tabindex="0"
    data-test-id="goToFirstPageButton"
  >
    <i class="icon icon--medium" data-test-id="firstPageButtonIcon"
      >first_page</i
    >
  </button>

  <button
    class="table__pagination__button"
    [disabled]="disablePrevious"
    type="button"
    (click)="goToPreviousPage()"
    [attr.aria-label]="'Go to previous page'"
    tabindex="0"
    data-test-id="goToPreviousPageButton"
  >
    <i class="icon icon--medium" data-test-id="previousPageButtonIcon"
      >chevron_left</i
    >
  </button>

  <button
    class="table__pagination__button"
    type="button"
    tabindex="0"
    data-test-id="pageButton"
  >
    <p class="t-data t-bold" data-test-id="pageButtonText">
      {{ currentPage }} / {{ totalCount }}
    </p>
  </button>

  <button
    class="table__pagination__button"
    type="button"
    [disabled]="disableNext"
    (click)="goToNextPage()"
    [attr.aria-label]="'Go to next page'"
    tabindex="0"
    data-test-id="goToNextPageButton"
  >
    <i class="icon icon--medium" data-test-id="nextPageButtonIcon"
      >chevron_right</i
    >
  </button>

  <button
    class="table__pagination__button"
    type="button"
    [disabled]="disableNext"
    (click)="goToLastPage()"
    data-test-id="goToLastPageButton"
    [attr.aria-label]="'Go to last page'"
    tabindex="0"
  >
    <i class="icon icon--medium" data-test-id="lastPageButtonIcon">last_page</i>
  </button>
</section>
